export default __webpack_public_path__ + "static/pricingfaqimg-86b60c05740a7eab2da7671b7443f04c.png";